<template>
  <VueIfBot>
    <transition name="slide-fade">
      <div v-if="shouldShowConsent" class="cookie-consent" role="dialog">
        <p class="text">
          <strong>We only have to do this once!</strong>
          We use cookies to give you the best experience. To learn more about our cookies, check out our
          <a
            href="https://www.animaapp.com/tos/TOS.pdf#page=9"
            target="_blank"
            rel="noopener noreferrer"
            class="privacy-link"
          >
            Privacy Policy
          </a>
        </p>

        <div class="buttons">
          <button class="btn btn-accept" @click="accept">Accept all</button>
          <button class="btn btn-reject" @click="reject">Reject non-essential cookies</button>
        </div>
      </div>
    </transition>
  </VueIfBot>
</template>

<script setup>
import VueIfBot from 'vue-if-bot';
import { useStore } from '@/store';
import { computed } from 'vue';
import { trackEvent } from '@/services/tracking';

const { dispatch, getters } = useStore();
const shouldShowConsent = computed(() => getters['consent/shouldShowConsent']);

const accept = () => {
  trackEvent('consent-banner.accept.click');
  dispatch('consent/grantConsent');
};

const reject = () => {
  trackEvent('consent-banner.reject.click');
  dispatch('consent/denyConsent');
};
</script>

<style lang="scss" scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 0 24px;
  height: 76px;
  background-color: #1e1e1e;
  z-index: 9999;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 16px;
    gap: 12px;
  }
}

.text {
  flex: 1;
  font-size: 14px;
  line-height: 1.5;
  color: #d1d5db;
  margin: 0;

  strong {
    color: white;
  }
}

.privacy-link {
  color: #a78bfa;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.buttons {
  display: flex;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
}

.btn {
  height: 32px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  @media (max-width: 768px) {
    flex: 1;
  }
}

.btn-accept {
  background-color: #6d54cf;
  color: white;

  &:hover {
    background-color: rgba(#6d54cf, 0.8);
  }
}

.btn-reject {
  background-color: transparent;
  color: #9ca3af;
  border: 1px solid rgba(white, 0.1);

  &:hover {
    background-color: rgba(white, 0.1);
    color: #d1d5db;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
